import React, { useState, useEffect } from "react";
import { TextField, Card, CardContent, Typography } from "@mui/material";
//import '../../css/SignUpForm.css'; // Optionally import a specific CSS file for the form
import SriyanshCardHeader from "../../components/CardHeader";
import DropdownfromDatabaseList from "../../CustomComponant/DropdownfromDatabaseList";
import { IconButton, InputAdornment } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import apiClient from "../../BaseUrl/apiClient.js";
import TokenService from "../../service/TokenService";
import EncryptService from "../../service/EncryptionService";
import { useNavigate } from "react-router-dom";

import { List, ListItem, ListItemText, Box } from "@mui/material"; // add for List Box
const SignUpForm = () => {
  const [role, setRole] = useState("");
  const [roles, setRoles] = useState([]);

  // add for List Box START/////////////
  const [list1, setList1] = useState([]);
  const [list2, setList2] = useState([]);

  const sortItems = (items) => {
    return [...items].sort((a, b) => a.Shop.localeCompare(b.Shop));
  };

  const handleTransferToSelected = (item) => {
    const updatedList1 = list1.filter(
      (i) => i.ConsigneeCode !== item.ConsigneeCode
    );
    const updatedList2 = [...list2, item];
    setList1(sortItems(updatedList1));
    setList2(sortItems(updatedList2));
  };

  const handleTransferToAvailable = (item) => {
    const updatedList2 = list2.filter(
      (i) => i.ConsigneeCode !== item.ConsigneeCode
    );
    const updatedList1 = [...list1, item];
    setList1(sortItems(updatedList1));
    setList2(sortItems(updatedList2));
  };

  // Fetch initial data from the database
  useEffect(() => {
    apiClient
      .post("/ConsigneeList")
      .then((response) => setList1(response.data), setList2([]))
      .catch((error) => console.error("Error fetching data:", error));
  }, [role]);

  // ///////////////////add for List Box END///////////////////

  // Function to fetch roles from the API


  const toProperCase = (str) =>
    str
      .replace(/^\s+/, "") // Remove leading spaces
      .replace(/\s+/g, " ")
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ")
      ;




  const fetchRoles = async () => {
    try {
      const response = await apiClient.post("/roleList", {
        /* request payload if needed */
      });
      setRoles(response.data); // Assuming response.data is an array of roles
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const [fname, setfName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  //const [role, setRole] = useState("user"); // Default role is 'user'
  const [errors, setErrors] = useState({});
  const [consignee, setconsignee] = useState("");
  const [consignees, setconsignees] = useState([]);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const handleClose = () => {
    navigate("../polist", { replace: true });
  };

  const fetchConsignees = async () => {
    try {
      const response = await apiClient.post("/ConsigneeList", {
        /* request payload if needed */
      });
      setconsignees(response.data);
      //setList1(response.data); // Assuming response.data is an array of roles
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  useEffect(() => {
    fetchConsignees();
    fetchRoles();
  }, []);

  useEffect(() => {
    if (consignees.length > 0) {
      setconsignee(consignees[0].ConsigneeCode);
    }

    if (roles.length > 0) {
      setRole(roles[2].id);
    }
  }, [consignees, roles, username]);

  const handleMobileNumberChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      // Allow only numeric values
      setMobileNumber(value);
    }
  };

  const tokenServiceDetails = TokenService.getUserDetails();
  const logineuname = tokenServiceDetails?.uname;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const InsertNewLogin = async (e) => {
    e.preventDefault();

    // uname,passwrd,rights,fname,email,mobile,cretedby,vip,

    let formErrors = {};
    if (!fname) formErrors.name = "Name is required";
    if (!email) formErrors.email = "Email is required";
    if (!password) formErrors.password = "Password is required";
    if (!username) formErrors.username = "Username is required";
    if (!mobileNumber) formErrors.mobileNumber = "Mobile number is required";
    if (mobileNumber && mobileNumber.length !== 10)
      formErrors.mobileNumber = "Mobile number must be 10 digits";
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email && !emailPattern.test(email)) {
      formErrors.email = "Email is invalid";
    }

    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      //vconsignee: role === 4 ? consignee : itemCodes,

      const itemCodes = list2.map((item) => item.ConsigneeCode).join(",");
      const vconsignee1 = (role === 3 || role === 4 || role === 6 ) ? itemCodes : consignee;
     // console.log(consignee);
     // console.log(role);
    //  console.log(itemCodes);
     // console.log(vconsignee1);

      apiClient
        .post("/newlogin", {
          uname: username,
          passwrd: password,
          rights: role,
          fname: fname,
          email: email,
          mobile: mobileNumber,
          cretedby: logineuname,
          vip: ip,
          vconsignee: vconsignee1.toString(),
        })
        .then(function (response) {
          setErrors(response.data);

          setfName("");
          setEmail("");
          setPassword("");
          setUsername("");
          setMobileNumber("");
          if (roles.length > 0) {
            setRole(roles[2].role);
          }
        })
        .catch(function (error) {
          if (
            error.response.data &&
            error.response.data.code === "ER_DUP_ENTRY"
          ) {
            alert("Duplicate User Not Allowed");
          }
        });
    }
  };

  return (
    <div>
     
      <Card className="Formcard ">
      <div className="input-groupHeading">
      Create New User

            </div>
        <CardContent>
          <div className="row">
          <div className="container">
            <div className="input-group">
              <TextField
                label="Full Name"
                variant="outlined"
                value={fname}
                size="small"
                onChange={(e) => setfName(toProperCase(e.target.value))}
                //onChange={(e) => setfName(e.target.value)}
                fullWidth
                error={!!errors.fname}
                helperText={errors.fname}
                inputProps={{ maxLength: 30 }}
              />
            </div>

            <div className="input-group">
              <TextField
                label="Email"
                variant="outlined"
                type="email"
                size="small"
                value={email}
                onChange={(e) => setEmail(e.target.value.toLowerCase())}
                fullWidth
                error={!!errors.email}
                helperText={errors.email}
                inputProps={{ maxLength: 50 }}
              />
            </div>
          </div>

          <div className="container">
            <div className="input-group">
              <TextField
                label="User ID"
                variant="outlined"
                size="small"
                value={username}
                onChange={(e) => setUsername(e.target.value.toLowerCase())}
                fullWidth
                error={!!errors.username}
                helperText={errors.username}
                inputProps={{ maxLength: 10 }}
              />
            </div>

            <div className="input-group">
              
              <TextField
                label="Password"
                variant="outlined"
                size="small"
                type={showPassword ? "text" : "password"}
                
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                fullWidth
                error={!!errors.password}
                helperText={errors.password}
                inputProps={{ maxLength: 15 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleClickShowPassword}
                        edge="end"
                        aria-label="toggle password visibility"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          </div>

          <div className="container">
            <div className="input-group">
              <TextField
                label="Mobile Number"
                size="small"
                variant="outlined"
                type="tel"
                value={mobileNumber}
                onChange={handleMobileNumberChange}
                fullWidth
                error={!!errors.mobileNumber}
                helperText={errors.mobileNumber}
                inputProps={{ maxLength: 10, pattern: "[0-9]*" }}
              />
            </div>

            <div className="input-group">
              <DropdownfromDatabaseList
              size="small"
                Options={roles} //ARRAY COMPONENT
                option={role} // VALUE VARIABLE
                setOptionValue={setRole} //SET VALUE VARIBALE
                DisplayItem1="role"
                DisplayItem2="id"
              />
            </div>
          </div>

          {(role === 3 || role === 4 || role=== 6 ) && (
            <div className="container">
              {/* List 1: Available Consignees */}
              <div className="input-group">
                <Box
                  sx={{
                    width: "100%",
                    border: "1px solid #ccc",
                    borderRadius: 2,
                    overflow: "auto",
                    maxHeight: 300, // Optional scrollable height
                  }}
                >
                  <Typography
                    variant="h6"
                    component="div"
                    sx={{
                      backgroundColor: "#f0f0f0",
                      padding: "8px",
                      borderBottom: "1px solid #ccc",
                      textAlign: "center",
                    }}
                  >
                    Available Consignees
                  </Typography>
                  <List>
                    {list1.map((item) => (
                      <ListItem
                        key={item.ConsigneeCode}
                        button
                        onClick={() => handleTransferToSelected(item)}
                      >
                        <ListItemText
                          primary={item.Shop}
                          secondary={item.ConsigneeCode}
                        />
                      </ListItem>
                    ))}
                  </List>
                </Box>
              </div>

              {/* List 2: Selected Consignees */}
              <div className="input-group">
                <Box
                  sx={{
                    width: "100%",
                    border: "1px solid #ccc",
                    borderRadius: 2,
                    overflow: "auto",
                    maxHeight: 300, // Optional scrollable height
                  }}
                >
                  <Typography
                    variant="h6"
                    component="div"
                    sx={{
                      backgroundColor: "#f0f0f0",
                      padding: "8px",
                      borderBottom: "1px solid #ccc",
                      textAlign: "center",
                    }}
                  >
                    Selected Consignees
                  </Typography>
                  <List>
                    {list2.map((item) => (
                      <ListItem
                        key={item.ConsigneeCode}
                        button
                        onClick={() => handleTransferToAvailable(item)}
                      >
                        <ListItemText
                          primary={item.Shop}
                          secondary={item.ConsigneeCode}
                        />
                      </ListItem>
                    ))}
                  </List>
                </Box>
              </div>
            </div>
          )}

          {role === 2 && (
            <div className="container">
              <div className="input-group">
                <DropdownfromDatabaseList
                  Options={consignees}
                  option={consignee}
                  setOptionValue={setconsignee}
                  DisplayItem1="Shop"
                  DisplayItem2="ConsigneeCode"
                  showKeyInLabel={true}
                  multiselect={true} // Enable multi-select
                />
              </div>
            </div>
          )}

          <>
            <div
              className="container flex"
              style={{
                display: "flex",
                paddingLeft: "40px",
                paddingRight: "40px",
                justifyContent: "space-between", // Distributes space between items
              }}
            >
              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={InsertNewLogin}
                title="Click for Data Entry"
              >
                Create Login
              </button>

              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={handleClose}
                title="Click for Data Save"
                style={{ backgroundColor: "red", color: "white" }}
              >
                Close
              </button>
            </div>
          </>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SignUpForm;
